// jsonTokens — split JSON text into coloured pieces, pure.
//
// The Ops report panel shows a stored report as JSON with keys, strings,
// numbers, literals and punctuation each in its own colour. The pieces are
// rendered as React text (escaped, never markup), and joined they are
// exactly the input: what is shown is what Copy JSON copies. O(n) in the
// text; anything the pattern does not know stays as a plain piece.

export { jsonTokens };

type JsonTokenKind =
    | "key"
    | "string"
    | "number"
    | "literal"
    | "punct"
    | "space";

type JsonToken = { readonly kind: JsonTokenKind; readonly text: string };

const PATTERN =
    /("(?:\\.|[^"\\])*")(?=\s*:)|("(?:\\.|[^"\\])*")|(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)|(true|false|null)|(\s+)|([^\s])/g;

const jsonTokens = (text: string): readonly JsonToken[] =>
    Array.from(text.matchAll(PATTERN), (m): JsonToken => {
        const piece = m[0];
        if (m[1] !== undefined) return { kind: "key", text: piece };
        if (m[2] !== undefined) return { kind: "string", text: piece };
        if (m[3] !== undefined) return { kind: "number", text: piece };
        if (m[4] !== undefined) return { kind: "literal", text: piece };
        if (m[5] !== undefined) return { kind: "space", text: piece };
        return { kind: "punct", text: piece };
    });
